import React from "react";

export default function Ournumbers() {
  return (
    <section
      id="numbers"
      className="flex flex-col justify-end min-h-screen md:h-screen text-white bg-right-bottom md:bg-top bg-fixed bg-sky-800"
      style={{ backgroundImage: `url('/discover/numbers-bg.webp')` }}
    >
      <div className="bg-body-secondary/50 h-4/5 md:mx-16">
        <h1 className="text-4xl text-center pt-32 underline underline-offset-8">Our Numbers</h1>
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between md:mt-16 h-1/2 content-center">
          <div className="stat-card-discover">
            <h1>6</h1>
            <p>Countries served</p>
          </div>
          <div className="stat-card-discover">
            <h1>91%</h1>
            <p>Average customer satisfaction score</p>
          </div>
          <div className="stat-card-discover">
            <h1>16</h1>
            <p>Industries served</p>
          </div>
        </div>
      </div>
    </section>
  );
}
